export function Field({ label, hint, required, children, testId }) {
  return (
    <div className="mb-5" data-testid={testId}>
      <label className="block text-sm font-semibold text-gray-800 mb-1.5">
        {label} {required && <span style={{ color: "#B5453D" }}>*</span>}
        {hint && <span className="text-xs text-gray-400 font-normal ml-1.5">{hint}</span>}
      </label>
      {children}
    </div>
  );
}

const baseInputClass =
  "w-full px-4 py-2.5 rounded-xl border text-sm text-gray-800 bg-white transition-all focus:outline-none focus:ring-2";

export function TextInput({ value, onChange, placeholder, type = "text", testId }) {
  return (
    <input
      type={type}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      className={baseInputClass}
      style={{ borderColor: "#DCE3E1", "--tw-ring-color": "#1D5C56" }}
    />
  );
}

export function TextArea({ value, onChange, placeholder, testId }) {
  return (
    <textarea
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={4}
      data-testid={testId}
      className={`${baseInputClass} resize-none`}
      style={{ borderColor: "#DCE3E1", "--tw-ring-color": "#1D5C56" }}
    />
  );
}

export function SelectInput({ value, onChange, options, testId }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className={`${baseInputClass} bg-white`}
      style={{ borderColor: "#DCE3E1", "--tw-ring-color": "#1D5C56" }}
    >
      <option value="">{"Select one\u2026"}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  );
}

export function DynamicField({ field, value, onChange }) {
  if (field.type === "select") {
    return <SelectInput value={value} onChange={onChange} options={field.opts} testId={`request-field-${field.id}`} />;
  }
  if (field.type === "textarea") {
    return <TextArea value={value} onChange={onChange} placeholder={field.placeholder} testId={`request-field-${field.id}`} />;
  }
  return <TextInput value={value} onChange={onChange} placeholder={field.placeholder} testId={`request-field-${field.id}`} />;
}
